module.exports = "/assets/data/3b5318096a641115a85b14971247bbf6-LL29.data.json";